<template>
  <div style="z-index: 10" v-show="isActive"
    class="map-tool-window legends-tool-window" :id="isFixed ? 'legendIDFix' : 'legendID'">
    <div v-if="!isFixed" class="map-tool-window-header" 

    id="legendIDheader">
      <p class="map-tool-window-header-title">Simbología</p>
      <div class="map-tool-window-header-actions">
          <button class="control-btn" @click="exitLegend()">
          <!-- <font-awesome-icon icon="times"></font-awesome-icon> -->
            <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
      
    </div>

    <div class="map-tool-window-body" v-show="!isHidden">

      <div :class="{ resizable: !isFixed }" v-if="activeLayers.length > 0">

        <div v-for="(layers, category) in groupedLayers" :key="category" class="legend-category">

          <div class="legend-category-title">
            {{ category }}
          </div>

          <div class="legend-category-content">
            <ListPlegableLegend v-for="(layer, i) in layers" :key="layer.id || i" :layer="layer" />
          </div>

        </div>
      </div>

      <div
        v-else
        class="no-data"
        :class="{ resizable: !isFixed }"
      >
        <div class="no-data-icon">
          <font-awesome-icon icon="layer-group" />
        </div>

        <strong>Sin simbología disponible</strong>

        <span>
          Activa una o más capas para visualizar su simbología.
        </span>
      </div>  
  </div>
</div> 
</template>

<script>
import ListPlegableLegend from "@/components/mapControls/legends/ListPlegableLegend.vue";
import { draggableDiv } from "@/components/mixin/draggableDiv.js";
import { vuex } from "@/components/mixin/vuex.js";

export default {
  name: "LegendPanel",
  props: ["isActive", "isFixed"],
  mixins: [draggableDiv, vuex],

  data() {
    return { isHidden: false };
  },

  components: { ListPlegableLegend },

  computed: {
    groupedLayers() {
      console.log("activeLayers en simbología:", this.activeLayers);
      const groups = {};
      for (const layer of this.activeLayers) {
        const cat = layer.category_name || "Sin categoría";
        if (!groups[cat]) groups[cat] = [];
        groups[cat].push(layer);
      }
      return groups;
    },
  },

  methods: {
    exitLegend() {
      this.$emit("onLegendAction", "legend", "exit", null);
    },
  },

  mounted() {
    this.makeDraggable("legendID");
  },
};
</script>

<style scoped lang="scss">

.legendContainer {
  left: 78vw;
  top: 4em;
  /* Card aesthetics */
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}
.legends-tool-window{
  left: 78vw;
  top: 4em;
}
// .widgetHeader {
//   background: #006FB3;
//   color: white;
//   padding: 10px 15px;
//   border-top-left-radius: 8px;
//   border-top-right-radius: 8px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }

.widgetBody {
  padding: 0;
  background: #f8fafc;
  max-height: 60vh;
  overflow-y: auto;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.resizable {
  margin-top: 0;
  height: auto;
  max-height: 60vh;
  min-height: 10vh;
  min-width: 15vw;
  resize: vertical;
  overflow: auto;
  padding: 10px;
}

.legend-category {
  margin-bottom: 1em;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.legend-category-title {
  background: var(--color-mist);
  color: var(--color-navy);
  padding: 8px 12px;
  font-weight: bold;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.legend-category-content {
  background: #ffffff;
  padding: 8px;
}

.widget-container-alt {
  position: relative;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;

  min-height: 150px;
  padding: 20px;

  background: var(--color-mist);
  border: 1px dashed var(--color-line);
  border-radius: 6px;

  text-align: center;

  strong {
    color: var(--color-navy);
    font-size: 0.9rem;
    font-weight: 700;
  }

  > span {
    max-width: 220px;

    color: var(--color-ghost);
    font-size: 0.78rem;
    line-height: 1.45;
  }
}

.no-data-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 38px;
  height: 38px;

  background: var(--color-white);
  border: 1px solid var(--color-line);
  border-radius: 50%;

  color: var(--color-steel);
  font-size: 1rem;
}
</style>